import classNames from 'classnames';
import { ReactElement } from 'react';

import { IMedicaidPlanType } from '~/services/api/medicaidPlan/types';
import TruncatedText from '~/ui/components/common/TruncatedText';

import ExpansionChip from '../ExpansionChip';

import styles from './MedicaidTypeLabel.module.scss';

interface IMedicaidTypeLabelProps {
  type: IMedicaidPlanType;
  multiline?: boolean;
}

const MedicaidTypeLabel = ({ type, multiline = false }: IMedicaidTypeLabelProps): ReactElement => (
  <span className={classNames(styles.label, { [styles.multiline]: multiline })}>
    {multiline ? (
      <TruncatedText>{type.name}</TruncatedText>
    ) : (
      <span className={styles.name}>{type.name}</span>
    )}
    {type.isExpansion && <ExpansionChip />}
  </span>
);

export default MedicaidTypeLabel;
